import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Downshift from 'downshift';
import { format, parseISO, isDate } from 'date-fns';
import isMobile from 'is-mobile';

import Calendar from '../Calendar';
import Input from '../Input';

import { ReactComponent as CalendarIcon } from 'icons/calendar.svg';

import s from './DateInput.module.css';

const DateInput = ({
  defaultValue,
  value,
  theme,
  name,
  error,
  disabled,
  fixedWidth,
  placeholder,
  withTime,
  onChange,
  yearsTopOffset,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [rawInputValue, setRawInputValue] = useState();
  const isDesktop = !isMobile();

  const selectedDate = value && ((isDate(value) && value) || (!isNaN(parseISO(value)) && parseISO(value)));

  const selectDate = (date, e) => {
    let result;
    if (!date) {
      result = null;
    } else if (isDate(value)) {
      result = date;
    } else {
      result = withTime ? date.toISOString() : format(date, 'y-MM-dd');
    }
    onChange(result, e);
  };

  const inputConfig = isDesktop
    ? {
        error,
        theme,
        fixedWidth,
        placeholder,
        disabled,
        className: s.input,
        active: isOpen,
        rightIcon: <CalendarIcon />,
        type: withTime ? 'datetime-local' : 'date',
        onClick: () => setOpen(!isOpen),
        value: rawInputValue || (selectedDate && format(selectedDate, withTime ? "y-MM-dd'T'HH:mm" : 'y-MM-dd')),
        onChange: (value, e) => {
          setRawInputValue(value);
          const date = parseISO(value);
          !isNaN(date) && selectDate(date);
        },
      }
    : {
        error,
        theme,
        fixedWidth,
        placeholder,
        disabled,
        onChange,
        value,
        rightIcon: <CalendarIcon />,
      };

  return (
    <Downshift
      isOpen={isOpen}
      onChange={selectDate}
      onSelect={() => setOpen(false)}
      onOuterClick={() => setOpen(false)}
      selectedItem={selectedDate || ''}
    >
      {({ getItemProps, isOpen }) => (
        <div className={cn(s.root, s[theme])}>
          <Input type="date" {...inputConfig} />
          {isDesktop && (
            <Calendar
              theme={theme}
              className={cn(s.calendar, { [s.visible]: isOpen })}
              disabled={!isOpen}
              startCurrentDateAt={selectedDate}
              selectedDate={selectedDate}
              getItemProps={getItemProps}
              yearsTopOffset={yearsTopOffset}
            />
          )}
        </div>
      )}
    </Downshift>
  );
};

DateInput.propTypes = {
  theme: PropTypes.oneOf(['field', 'toolbar-white']),
  onChange: PropTypes.func,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  fixedWidth: PropTypes.number,
  withTime: PropTypes.bool,
};

DateInput.defaultProps = {
  theme: 'field',
  onChange: () => {},
  placeholder: undefined,
  defaultValue: undefined,
  fixedWidth: undefined,
  disabled: false,
  withTime: false,
  error: false,
};

export default DateInput;
